export default __webpack_public_path__ + "static/media/news104.64526fa5.jpg";